import type { RefreshCollectionThreadFromFamousOutput } from '@erp/rpc';

/**
 * What the user should be told about a thread-open Famous refresh.
 *
 * - `resolved` — the refresh settled the thread. Consequential: it changes what
 *   the user can do next and may have landed while they were mid-draft, so it
 *   earns a persistent banner.
 * - `updated`  — the invoice moved but the thread is still open. Informational;
 *   a quiet toast.
 * - `none`     — nothing ran, or nothing changed. Say nothing at all.
 *
 * Every input field means "this actually changed" — the handler diffs the
 * invoice either side of the refresh rather than reporting the ingest's upsert
 * counts, which are non-zero on any re-ingest of unchanged data.
 */
export type ThreadRefreshOutcome = 'resolved' | 'updated' | 'none';

export function threadRefreshOutcome(
  result: RefreshCollectionThreadFromFamousOutput,
): ThreadRefreshOutcome {
  if (result.skipped) return 'none';
  if (result.threadResolved) return 'resolved';
  if (result.balanceChanged || result.newPaymentsApplied > 0) return 'updated';
  return 'none';
}
